import type { AbstractMesh, TransformNode } from "@babylonjs/core";

/**
 * Parents a freshly imported GLB's top-level meshes to the entity root, moving the model so its lowest
 * point rests on the placement point. The server's get_plot bounds assume exactly this (spec 2l §3.4).
 * The loader's __root__ has no vertices and a bounding box pinned at the origin, so it is skipped:
 * counting it would leave a model that floats above its origin floating.
 */
export function attachImported(meshes: AbstractMesh[], root: TransformNode): void {
  let minY = Infinity;
  for (const m of meshes) {
    if (m.getTotalVertices() > 0) minY = Math.min(minY, m.getBoundingInfo().boundingBox.minimumWorld.y);
  }
  for (const m of meshes.filter((m) => !m.parent)) {
    m.parent = root;
    if (Number.isFinite(minY)) m.position.y -= minY;
  }
}
